import { render } from "./AutocompleteSearch.vue?vue&type=template&id=2c03eca0&scoped=true"
import script from "./AutocompleteSearch.vue?vue&type=script&lang=js"
export * from "./AutocompleteSearch.vue?vue&type=script&lang=js"

import "./AutocompleteSearch.vue?vue&type=style&index=0&id=2c03eca0&scoped=true&lang=css"

import exportComponent from "/Users/renzocappelli/Lavoro/bikinilovers/newPosBKL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03eca0"]])

export default __exports__